
export function formatDate(date) {
  if (!date) return '';

  const d = date instanceof Date ? date : new Date(date);

  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d);
}